import { Badge, type BadgeProps } from "@/components/ui/badge";
import type {
  BulkImportBatchStatus,
  BulkImportRowStatus,
} from "@/features/bulk-imports";

type ImportStatus = BulkImportBatchStatus | BulkImportRowStatus;

interface BulkImportStatusBadgeProps {
  status: ImportStatus;
  className?: string;
}

const statusMeta: Record<
  ImportStatus,
  { label: string; variant: BadgeProps["variant"] }
> = {
  uploaded: { label: "Subido", variant: "outline" },
  validating: { label: "Validando", variant: "secondary" },
  validated: { label: "Validado", variant: "secondary" },
  committing: { label: "Contabilizando", variant: "secondary" },
  committed: { label: "Contabilizado", variant: "default" },
  partially_committed: { label: "Parcial", variant: "outline" },
  failed: { label: "Fallido", variant: "destructive" },
  cancelled: { label: "Cancelado", variant: "outline" },
  pending: { label: "Pendiente", variant: "outline" },
  valid: { label: "Valida", variant: "secondary" },
  invalid: { label: "Error", variant: "destructive" },
  skipped: { label: "Omitida", variant: "outline" },
  commit_failed: { label: "Error commit", variant: "destructive" },
};

export function BulkImportStatusBadge({
  status,
  className,
}: BulkImportStatusBadgeProps) {
  const meta = statusMeta[status];

  return (
    <Badge variant={meta.variant} className={className}>
      {meta.label}
    </Badge>
  );
}
